var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{ref:"siteContainer",staticClass:"site-container js-site-scroll-adapt",style:({ maxWidth: _vm.siteContainerMaxWidth, minHeight: _vm.minHeight })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }